import { render, staticRenderFns } from "./ProsList.vue?vue&type=template&id=3d107388&scoped=true"
import script from "./ProsList.vue?vue&type=script&lang=js"
export * from "./ProsList.vue?vue&type=script&lang=js"
import style0 from "./ProsList.vue?vue&type=style&index=0&id=3d107388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d107388",
  null
  
)

export default component.exports